<div *siExternalReference="false" class="top-bar {{styleClass}}">
  <div *ngIf="isMobile">
    <si-history-back-icon styleClass="mr-2"></si-history-back-icon>
  </div>
  <div class="top-bar_logo" *ngIf="!isMobile || showLogoForce">
    <a [routerLink]="['/']" class="top-bar_logo_link">
      <img src="assets/images/logotipo.svg">
      <!--      <span class="ml-2">{{appTitle | translate}}</span>-->
    </a>
  </div>
  <div class="d-none d-sm-block ml-5">
    <div class="row">
      <div class="col d-none d-md-flex align-items-center">
        <si-breadcrumb></si-breadcrumb>
      </div>
    </div>
  </div>
  <div class="row no-gutters ml-auto">
    <div tourAnchor="home.notification" class="col-auto top-bar_notification-box mr-3 mr-sm-4" *ngIf="showNotificationBox">
      <si-notification-box-icon></si-notification-box-icon>
    </div>
    <div class="col-auto top-bar_appo-request-icon mr-3 mr-sm-4" *ngIf="showAppoRequestIcon">
      <si-appo-request-icon></si-appo-request-icon>
    </div>
    <div class="col-auto top-bar_faq-icon mr-3 mr-sm-4">
      <si-faq-icon></si-faq-icon>
    </div>
    <div tourAnchor="home.language" class="col-auto mr-3 mr-sm-4 d-flex align-items-center" *ngIf="languageValues.length > 1 && isStorageActive | async">
      <si-translation></si-translation>
    </div>
    <div tourAnchor="home.menu" class="col-auto top-bar_hamburguermenu mr-1 mr-sm-3 outsideCloseNavSidebar" *ngIf="showMenu">
      <i class="{{openMenu ? 'icosun-close' : 'icosun-menu'}}" (click)="onClickMenu($event)"></i>
    </div>
  </div>
</div>
